var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.5696 11.5H11.5696V17.5H9.56958V11.5H3.56958V9.5H9.56958V3.5H11.5696V9.5H17.5696V11.5Z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }